module.exports = __webpack_public_path__ + "img/data.0d449639.svg";